<template>
  <div
    class="person__container"
  >
    <h3 class="person__title">
      Darsteller:
    </h3>
    <div class="person__wrapper">
      <div
        v-if="credits.length > 0"
        class="person__inner"
      >
        <div
          v-for="actor in credits"
          :key="actor.id"
          class="person__card"
        >
          <div class="elevation-5">
            <router-link
              class="person__link"
              :to="'/person/' + actor.id"
            >
              <v-lazy-image
                :src="actor.profile_path ? `${profilePrefix}${actor.profile_path}` : noAvatarSrc"
                :src-placeholder="gradient"
                class="person__img"
              />

              <div class="person__text">
                <h3 class="body-2 main--text text-no-wrap text-truncate ma-0 my-1">
                  {{ actor.name }}
                </h3>
                <p class="person__name">
                  {{ actor.character ? actor.character : `------` }}
                </p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
      <div v-else>
        <p
          class="tvshow__no-actors"
        >
          Wias ausschaut fein do de Infos für de Schauspieler vo dem Film
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { base } from '../config/config';

const noAvatarSrc = require('../assets/avatar.jpg');
const gradient = require('../assets/gradient.jpg');

export default {
  props: {
    credits: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      profilePrefix: base.medProfilePrefix,
      noAvatarSrc,
      gradient,
    };
  },

};
</script>

<style lang="scss" scoped>
.v-lazy-image {
  display: block;
  width: 100%;
  filter: blur(10px);
  transition: filter 0.7s;
}

.v-lazy-image-loaded {
  filter: blur(0);
}

.person {
  &__title {
    width: 100%;
    font-weight: 300;
    margin-bottom: 15px;
    font-size: 20px;
    border-bottom: 1px solid #546e7a;

    @media (max-width: 768px) {
      font-size: 18px;
    }

    @media (max-width: 600px) {
      margin-bottom: 10px;
    }
  }

  &__wrapper {
    overflow-x: auto;
    @media (max-width: 600px) {
      overflow-x: scroll;
    }
  }

  &__inner {
    display: flex;
    justify-content: space-between;
    padding: 5px 0;

    // @media (max-width: 600px) {
    //   width: 570px;
    // }
  }

  &__card {
    min-width: 13.3%;
    max-width: 13.3%;
    margin-right: 13px;
    transition: transform 0.25s ease-in-out;

    &:hover {
      @media (min-width: 959px) {
        transform: translateY(-5px);
      }
    }

    &:last-child {
      margin-right: auto;
    }

    @media (max-width: 420px) {
      min-width: 47%;
      max-width: 47%;
    }

    @media (max-width: 600px) and (min-width: 421px) {
      min-width: 24.99%;
      max-width: 24.99%;
    }

    @media (max-width: 959px) and (min-width: 601px) {
      min-width: 18.3%;
      max-width: 18.3%;
    }

    @media (min-width: 960px) {
      min-width: 15.4%;
      max-width: 15.4%;
    }

    @media (min-width: 1264px) {
      min-width: 13.3%;
      max-width: 13.3%;
    }
  }

  &__link {
    text-decoration: none;
  }

  &__picture {
    display: block;
  }

  &__img {
    object-fit: fill;
    border-radius: 3px 3px 0 0;

    @media (max-width: 420px) {
      height: 250px;
    }

    @media (max-width: 600px) and (min-width: 421px) {
      height: 210px;
    }

    @media (max-width: 959px) and (min-width: 601px) {
      height: 205px;
    }

    @media (min-width: 960px) {
      height: 195px;
    }

    @media (min-width: 1264px) {
      height: 225px;
    }
  }

  &__text {
    color: #303030;
    padding: 5px;
    text-align: center;
    font-size: 12px;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 0 0 3px 3px;
  }

  &__cred,
  &__name {
    margin: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  &__cred {
    font-weight: 400;
  }

}

</style>
